module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Regular.b76d6a525a3299cdfbab0aa9aae78e24.woff2";